import { Options } from "../highcharts/options";

export class TileMetaData {
    calcRef: number;
    chartType: string;
    dashboardItemRef: string;
    data: Options;
}
